export enum PurchasePlanningLevels {
  GROUP_LEVEL_PLANNING = 'GROUP_LEVEL_PLANNING',
  PARTNER_LEVEL_PLANNING = 'PARTNER_LEVEL_PLANNING',
  SOLO_LEVEL_PLANNING = 'SOLO_LEVEL_PLANNING',
}
